import React from "react";

export default function SignDocumentsStep({ setCurrentStep, selectedOffer }) {
  const handleReviewAndSign = () => {
    // Move to the Terms & Conditions (KFS) step
    setCurrentStep(16); 
  };

  const lenderName = selectedOffer?.lender_name || "CredFin";

  const documents = [
    {
      id: "app",
      name: "Loan Application",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
        </svg>
      )
    },
    {
      id: "sanction",
      name: "Sanction Letter",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
          <polyline points="14 2 14 8 20 8"></polyline>
          <path d="M16 13H8"></path>
          <path d="M16 17H8"></path>
          <path d="M10 9H8"></path>
        </svg>
      )
    },
    {
      id: "kfs",
      name: "Key Fact Statement",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"></path>
        </svg>
      )
    },
    {
      id: "agreement",
      name: "Loan Agreement",
      icon: (
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
        </svg>
      )
    }
  ];

  return (
    <div className="w-full max-w-[400px] mx-auto bg-white min-h-[100dvh] font-atkinson flex flex-col relative pb-[100px]">
      
      {/* Header & Progress Bar */}
      <div className="px-5 pt-6 pb-4 border-b border-transparent">
        <div className="flex justify-center mb-4">
          <div className="text-center leading-none">
            <h1 className="text-[#205A6D] font-bold text-[22px] tracking-tight">
              {lenderName}
            </h1>
            <p className="text-[#7ea4b1] text-[9px] font-semibold tracking-widest mt-1 uppercase">Loans made Easy</p>
          </div>
        </div>
        
        <div className="flex items-center justify-between">
          <button onClick={() => setCurrentStep(14)} className="w-6 h-6 flex items-center justify-start text-gray-700">
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
          </button>
          
          <div className="flex-1 mx-4 h-[4px] bg-[#e6f4ed] rounded-full overflow-hidden">
            <div className="h-full bg-[#12f280] w-[83%] rounded-full"></div>
          </div>
          <span className="text-[12px] text-gray-500 font-medium">83%</span>
        </div>
      </div>

      {/* Main Content */}
      <div className="px-5 pt-2 flex-1">
        <h2 className="text-[22px] font-bold text-[#1b1b1b]">Sign Loan Documents</h2>
        <p className="text-[13px] text-[#8b8b8b] mt-2 mb-6 leading-relaxed pr-2">
          By clicking eSign button, you proceed to sign loan agreement and other loan related documents.
        </p>

        <div className="flex flex-col gap-3">
          {documents.map((doc) => (
            <div 
              key={doc.id}
              className="flex items-center p-4 rounded-[16px] border border-[#f0f0f0] bg-white hover:border-[#e5e5e5] transition-colors cursor-pointer shadow-sm"
            >
              {/* Document Icon Container */}
              <div className="w-[42px] h-[42px] rounded-[12px] bg-[#F5F5F5] flex items-center justify-center text-[#8b8b8b] flex-none mr-4">
                {doc.icon}
              </div>

              {/* Title */}
              <div className="flex-1">
                <h3 className="font-bold text-[14.5px] text-[#1b1b1b]">
                  {doc.name}
                </h3>
              </div>

              {/* Chevron Right */}
              <div className="flex-none w-5 h-5 flex items-center justify-center text-[#cccccc]">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9 18l6-6-6-6"/>
                </svg>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Sticky Bottom Button */}
      <div className="fixed bottom-0 left-0 right-0 z-50 mx-auto w-full max-w-[400px] bg-white px-5 py-4 border-t border-transparent">
        <button 
          onClick={handleReviewAndSign}
          className="w-full bg-black text-white font-bold text-[16px] rounded-[14px] py-[18px] active:scale-[0.98] transition-transform"
        >
          Review & Sign
        </button>
      </div>
    </div>
  );
}